import { Typography } from '../Typography'
import { StyledOption } from './styles'

interface OptionNodeProps {
  selected: boolean
  value: string | number
  text: string
  icon?: string
  onClick: (value: string | number) => void
  onIconError?: string
  disabled: boolean
}

export const OptionNode = ({
  selected,
  value,
  text,
  icon,
  onClick,
  onIconError,
  disabled,
}: OptionNodeProps) => (
  <StyledOption
    disabled={disabled}
    onClick={() => {
      if (!disabled) onClick(value)
    }}
    selected={selected}
  >
    {icon && (
      <img
        alt="option icon"
        onError={({ currentTarget }) => {
          // eslint-disable-next-line no-param-reassign
          currentTarget.onerror = null
          // eslint-disable-next-line no-param-reassign
          currentTarget.src = onIconError ?? ''
        }}
        src={icon}
      />
    )}
    <Typography ellipsis variant="placeholder">
      {text}
    </Typography>
  </StyledOption>
)
